import React from 'react';

const VideoIcon = () => {
return(
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M7 13.9123C10.4794 13.9123 13.3 11.0918 13.3 7.6123C13.3 4.13291 10.4795 1.31229 7 1.31229C3.52061 1.31229 0.699985 4.13291 0.699985 7.6123C0.699985 11.0917 3.52061 13.9123 7 13.9123ZM7 14.6123C10.8659 14.6123 14 11.4783 14 7.6123C14 3.74628 10.8659 0.612305 7 0.612305C3.13398 0.612305 0 3.74628 0 7.6123C0 11.4783 3.13398 14.6123 7 14.6123Z"
              fill="#333333"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8.81652 7.60926L5.59752 5.46328V9.75531L8.81652 7.60926ZM9.46687 7.20158C9.75784 7.39556 9.75784 7.82304 9.46687 8.01702L5.65927 10.5555C5.33366 10.7726 4.89746 10.5391 4.89746 10.1477V5.07089C4.89746 4.67953 5.33366 4.4461 5.65927 4.66321L9.46687 7.20158Z"
              fill="#333333"/>
    </svg>
)

}
export default VideoIcon;

